module.exports = __webpack_public_path__ + "img/service_03.63dff40a.png";